/* eslint-disable sort-imports */
import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import authentication from './features/authentication/reducers';
import characterDetail from './features/characterDetail/reducers';
import comments from './features/comments/reducers';
import community from './features/community/reducers';
import dashboard from './features/dashboard/reducers';
import layout from './features/layout/reducers';
import lessonDetail from './features/lessonDetail/reducers';
import library from './features/library/reducers';
import newCommunityPost from './features/newCommunityPost/reducers';
import passwordManagement from './features/passwordManagement/reducers';
import shared from './features/shared/reducers';
import sideNavigationBadges from './features/sideNavigationBadges/reducers';
import sideNavigationTitle from './features/sideNavigationTitle/reducers';
import stateMandates from './features/stateMandates/reducers';
import userProfile from './features/userProfile/reducers';
import users from './features/users/reducers';

const rootReducer = combineReducers({
  features: combineReducers({
    authentication,
    characterDetail,
    comments,
    community,
    dashboard,
    layout,
    lessonDetail,
    library,
    newCommunityPost,
    passwordManagement,
    shared,
    sideNavigationBadges,
    sideNavigationTitle,
    stateMandates,
    userProfile,
    users,
  }),
  routing: routerReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./app/rootReducer.js